"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function pura(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M8.39412 5.625H14.2171C15.8281 5.72025 17.6004 6.3825 18.3121 7.92C19.2024 9.87825 18.7599 12.6323 16.7544 13.7498C14.9049 14.8073 12.6924 14.3902 10.6614 14.4772C10.6066 15.4777 10.8864 16.6417 10.1889 17.4877C9.90837 17.8927 8.62212 18.375 8.62212 18.375C8.62212 18.375 8.50362 17.2883 8.46012 14.8425C8.43237 14.1675 8.54262 13.41 9.12237 12.9713C9.80112 12.3878 10.7634 12.57 11.5876 12.54C12.8326 12.507 14.1406 12.6975 15.3226 12.2175C17.0566 11.5088 17.1196 8.6145 15.3721 7.88475C13.5879 7.19325 11.6176 7.8225 9.78462 7.44C8.95212 7.20675 8.57787 6.387 8.39412 5.625ZM5.25012 8.9475C6.77262 8.97525 8.29812 8.89425 9.81762 8.98575C10.9224 9.0705 11.6476 10.071 11.7631 11.094C10.2301 11.0865 8.69337 11.1428 7.15962 11.0753C6.21762 11.0205 5.52237 10.2555 5.25012 9.41175V8.94825V8.9475Z", fill: color }));
}
exports["default"] = pura;
//# sourceMappingURL=pura.js.map